module.exports = __webpack_public_path__ + "static/media/5DPO3.2b8f2e23.jpg";